export default "__VITE_ASSET__$NFC59VZ__"